import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// pkg/dist-src/index.js
import BottleneckLight from "bottleneck/light";
import { Octokit } from "@octokit/core"; // pkg/dist-src/version.js

var VERSION = "8.1.3"; // pkg/dist-src/wrap-request.js

var noop = function noop() {
  return Promise.resolve();
};

function wrapRequest(state, request, options) {
  return state.retryLimiter.schedule(doRequest, state, request, options);
}

function doRequest(_x, _x2, _x3) {
  return _doRequest.apply(this, arguments);
} // pkg/dist-src/generated/triggers-notification-paths.js


function _doRequest() {
  _doRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state, request, options) {
    var isWrite, _URL2, pathname, isSearch, isGraphQL, retryCount, jobOptions, req, res, error;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isWrite = options.method !== "GET" && options.method !== "HEAD";
            _URL2 = new URL(options.url, "http://github.test"), pathname = _URL2.pathname;
            isSearch = options.method === "GET" && pathname.startsWith("/search/");
            isGraphQL = pathname.startsWith("/graphql");
            retryCount = ~~request.retryCount;
            jobOptions = retryCount > 0 ? {
              priority: 0,
              weight: 0
            } : {};

            if (state.clustering) {
              jobOptions.expiration = 1e3 * 60;
            }

            if (!(isWrite || isGraphQL)) {
              _context3.next = 10;
              break;
            }

            _context3.next = 10;
            return state.write.key(state.id).schedule(jobOptions, noop);

          case 10:
            if (!(isWrite && state.triggersNotification(pathname))) {
              _context3.next = 13;
              break;
            }

            _context3.next = 13;
            return state.notifications.key(state.id).schedule(jobOptions, noop);

          case 13:
            if (!isSearch) {
              _context3.next = 16;
              break;
            }

            _context3.next = 16;
            return state.search.key(state.id).schedule(jobOptions, noop);

          case 16:
            req = state.global.key(state.id).schedule(jobOptions, request, options);

            if (!isGraphQL) {
              _context3.next = 24;
              break;
            }

            _context3.next = 20;
            return req;

          case 20:
            res = _context3.sent;

            if (!(res.data.errors != null && res.data.errors.some(function (error) {
              return error.type === "RATE_LIMITED";
            }))) {
              _context3.next = 24;
              break;
            }

            error = Object.assign(new Error("GraphQL Rate Limit Exceeded"), {
              response: res,
              data: res.data
            });
            throw error;

          case 24:
            return _context3.abrupt("return", req);

          case 25:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _doRequest.apply(this, arguments);
}

var triggers_notification_paths_default = ["/orgs/{org}/invitations", "/orgs/{org}/invitations/{invitation_id}", "/orgs/{org}/teams/{team_slug}/discussions", "/orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments", "/repos/{owner}/{repo}/collaborators/{username}", "/repos/{owner}/{repo}/commits/{commit_sha}/comments", "/repos/{owner}/{repo}/issues", "/repos/{owner}/{repo}/issues/{issue_number}/comments", "/repos/{owner}/{repo}/pulls", "/repos/{owner}/{repo}/pulls/{pull_number}/comments", "/repos/{owner}/{repo}/pulls/{pull_number}/comments/{comment_id}/replies", "/repos/{owner}/{repo}/pulls/{pull_number}/merge", "/repos/{owner}/{repo}/pulls/{pull_number}/requested_reviewers", "/repos/{owner}/{repo}/pulls/{pull_number}/reviews", "/repos/{owner}/{repo}/releases", "/teams/{team_id}/discussions", "/teams/{team_id}/discussions/{discussion_number}/comments"]; // pkg/dist-src/route-matcher.js

function routeMatcher(paths) {
  var regexes = paths.map(function (path) {
    return path.split("/").map(function (c) {
      return c.startsWith("{") ? "(?:.+?)" : c;
    }).join("/");
  });
  var regex2 = "^(?:".concat(regexes.map(function (r) {
    return "(?:".concat(r, ")");
  }).join("|"), ")[^/]*$");
  return new RegExp(regex2, "i");
} // pkg/dist-src/index.js


var regex = routeMatcher(triggers_notification_paths_default);
var triggersNotification = regex.test.bind(regex);
var groups = {};

var createGroups = function createGroups(Bottleneck, common) {
  groups.global = new Bottleneck.Group(_objectSpread({
    id: "octokit-global",
    maxConcurrent: 10
  }, common));
  groups.search = new Bottleneck.Group(_objectSpread({
    id: "octokit-search",
    maxConcurrent: 1,
    minTime: 2e3
  }, common));
  groups.write = new Bottleneck.Group(_objectSpread({
    id: "octokit-write",
    maxConcurrent: 1,
    minTime: 1e3
  }, common));
  groups.notifications = new Bottleneck.Group(_objectSpread({
    id: "octokit-notifications",
    maxConcurrent: 1,
    minTime: 3e3
  }, common));
};

function throttling(octokit, octokitOptions) {
  var _ref = octokitOptions.throttle || {},
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      _ref$Bottleneck = _ref.Bottleneck,
      Bottleneck = _ref$Bottleneck === void 0 ? BottleneckLight : _ref$Bottleneck,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "no-id" : _ref$id,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1e3 * 60 * 2 : _ref$timeout,
      connection = _ref.connection;

  if (!enabled) {
    return {};
  }

  var common = {
    connection: connection,
    timeout: timeout
  };

  if (groups.global == null) {
    createGroups(Bottleneck, common);
  }

  var state = Object.assign(_objectSpread({
    clustering: connection != null,
    triggersNotification: triggersNotification,
    fallbackSecondaryRateRetryAfter: 60,
    retryAfterBaseValue: 1e3,
    retryLimiter: new Bottleneck(),
    id: id
  }, groups), octokitOptions.throttle);

  if (typeof state.onSecondaryRateLimit !== "function" || typeof state.onRateLimit !== "function") {
    throw new Error("octokit/plugin-throttling error:\n        You must pass the onSecondaryRateLimit and onRateLimit error handlers.\n        See https://octokit.github.io/rest.js/#throttling\n\n        const octokit = new Octokit({\n          throttle: {\n            onSecondaryRateLimit: (retryAfter, options) => {/* ... */},\n            onRateLimit: (retryAfter, options) => {/* ... */}\n          }\n        })\n    ");
  }

  var events = {};
  var emitter = new Bottleneck.Events(events);
  events.on("secondary-limit", state.onSecondaryRateLimit);
  events.on("rate-limit", state.onRateLimit);
  events.on("error", function (e) {
    return octokit.log.warn("Error in throttling-plugin limit handler", e);
  });
  state.retryLimiter.on("failed", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error, info) {
      var _info$args, state2, request, options, _URL, pathname, shouldRetryGraphQL, retryCount, _yield, wantRetry, _yield$retryAfter, retryAfter;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _info$args = _slicedToArray(info.args, 3), state2 = _info$args[0], request = _info$args[1], options = _info$args[2];
              _URL = new URL(options.url, "http://github.test"), pathname = _URL.pathname;
              shouldRetryGraphQL = pathname.startsWith("/graphql") && error.status !== 401;

              if (shouldRetryGraphQL || error.status === 403) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              retryCount = ~~request.retryCount;
              request.retryCount = retryCount;
              options.request.retryCount = retryCount;
              _context2.next = 10;
              return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _error$response$data$, _error$response$data;

                var retryAfter2, wantRetry2, rateLimitReset, _retryAfter, _wantRetry;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!/\bsecondary rate\b/i.test(error.message)) {
                          _context.next = 6;
                          break;
                        }

                        retryAfter2 = Number(error.response.headers["retry-after"]) || state2.fallbackSecondaryRateRetryAfter;
                        _context.next = 4;
                        return emitter.trigger("secondary-limit", retryAfter2, options, octokit, retryCount);

                      case 4:
                        wantRetry2 = _context.sent;
                        return _context.abrupt("return", {
                          wantRetry: wantRetry2,
                          retryAfter: retryAfter2
                        });

                      case 6:
                        if (!(error.response.headers != null && error.response.headers["x-ratelimit-remaining"] === "0" || ((_error$response$data$ = (_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errors) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : []).some(function (error2) {
                          return error2.type === "RATE_LIMITED";
                        }))) {
                          _context.next = 13;
                          break;
                        }

                        rateLimitReset = new Date(~~error.response.headers["x-ratelimit-reset"] * 1e3).getTime();
                        _retryAfter = Math.max( // Add one second so we retry _after_ the reset time
                        // https://docs.github.com/en/rest/overview/resources-in-the-rest-api?apiVersion=2022-11-28#exceeding-the-rate-limit
                        Math.ceil((rateLimitReset - Date.now()) / 1e3) + 1, 0);
                        _context.next = 11;
                        return emitter.trigger("rate-limit", _retryAfter, options, octokit, retryCount);

                      case 11:
                        _wantRetry = _context.sent;
                        return _context.abrupt("return", {
                          wantRetry: _wantRetry,
                          retryAfter: _retryAfter
                        });

                      case 13:
                        return _context.abrupt("return", {});

                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }))();

            case 10:
              _yield = _context2.sent;
              wantRetry = _yield.wantRetry;
              _yield$retryAfter = _yield.retryAfter;
              retryAfter = _yield$retryAfter === void 0 ? 0 : _yield$retryAfter;

              if (!wantRetry) {
                _context2.next = 17;
                break;
              }

              request.retryCount++;
              return _context2.abrupt("return", retryAfter * state2.retryAfterBaseValue);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }());
  octokit.hook.wrap("request", wrapRequest.bind(null, state));
  return {};
}

throttling.VERSION = VERSION;
throttling.triggersNotification = triggersNotification;
export { throttling };